import { OrderDirection } from "_shared/_api/ordering/order-direction";
import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import AHDate from "_shared/dates/date";

export class NetworkedGroupFilterParameters {
  public query?: string;
  public name?: string;
  public description?: string;
  public minCreatedDate?: AHDate;
  public maxCreatedDate?: AHDate;

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.query) searchParams.append("query", this.query);
    if (this.name) searchParams.append("name", this.name);
    if (this.description) searchParams.append("description", this.description);
    if (this.minCreatedDate) searchParams.append("minCreatedDate", this.minCreatedDate.toISOString());
    if (this.maxCreatedDate) searchParams.append("maxCreatedDate", this.maxCreatedDate.toISOString());
    return searchParams;
  }

  public constructor(name?: string, description?: string, minCreatedDate?: AHDate, maxCreatedDate?: AHDate) {
    this.name = name;
    this.description = description;
    this.minCreatedDate = minCreatedDate;
    this.maxCreatedDate = maxCreatedDate;
  }

  public isEqualTo(other: NetworkedGroupFilterParameters): boolean {
    if (!other) return false;
    return Boolean(
      this.query === other.query &&
        this.name === other.name &&
        this.description === other.description &&
        this.minCreatedDate?.isEqualTo(other.minCreatedDate) &&
        this.maxCreatedDate?.isEqualTo(other.maxCreatedDate)
    );
  }

  public toString(): string {
    return `NetworkedGroupFilterParameters {
      query: ${this.query},
      name: ${this.name},
      description: ${this.description},
      minCreatedDate: ${this.minCreatedDate?.toISOString()},
      maxCreatedDate: ${this.maxCreatedDate?.toISOString()}
    }`;
  }
}

export enum NetworkedGroupOrderField {
  Name = "Name",
  Description = "Description",
  Created = "Created",
}

export class NetworkedGroupOrderParameters {
  public get searchParams(): URLSearchParams {
    const params = new URLSearchParams();
    if (this.orderBy) params.append("orderBy", this.orderBy);
    if (this.orderDir) params.append("orderDir", this.orderDir);
    return params;
  }

  public constructor(public orderBy?: NetworkedGroupOrderField, public orderDir?: OrderDirection) {}

  public isEqualTo(other: NetworkedGroupOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }

  public toString(): string {
    return `NetworkedGroupOrderParameters {
      orderBy: ${this.orderBy},
      orderDir: ${this.orderDir}
    }`;
  }
}

export default class NetworkedGroupQuery {
  public get searchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.paginationParameters.searchParams,
      ...this.orderParameters.searchParams,
      ...this.filterParameters.searchParams,
    ]);
  }

  public constructor(
    public filterParameters: NetworkedGroupFilterParameters,
    public orderParameters: NetworkedGroupOrderParameters,
    public paginationParameters: PaginationParameters
  ) {
    this.paginationParameters = paginationParameters;
    this.orderParameters = orderParameters;
    this.filterParameters = filterParameters;
  }

  public isEqualTo(other: NetworkedGroupQuery): boolean {
    if (!other) {
      return false;
    }
    return (
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }

  public toString(): string {
    return `NetworkedGroupQuery {
      filterParameters: ${this.filterParameters.toString()},
      orderParameters: ${this.orderParameters.toString()},
      paginationParameters: ${this.paginationParameters.toString()}
    }`;
  }
}
